class Sidebar {

    constructor($templateCache) {

      return {
          restrict: 'E',
          transclude: true,
          replace: true,
          templateUrl: 'sidebar.html'
      };

    }

}

angular.module('cpm')
    .directive('sidebar', () => {
        'use strict';
        return new Sidebar();
    });
